/**
 * 電柱情報
 */
export class PoleItem {
  /**
   * コンストラクタ
   */
  constructor({
    areaCode, areaName,
    latitude, longitude, poleKind,
    lineCode, lineName, poleNo,
  }) {
    this.areaCode  = toText(areaCode, 2);    // 地区コード
    this.lineCode  = toText(lineCode, 4);    // 線路コード
    this.poleNo    = poleNo;                 // 電柱番号
    this.latitude  = latitude;               // 緯度
    this.longitude = longitude;              // 経度
    this.poleKind  = poleKind;               // 電柱区分
    this.areaName  = areaName;               // 地区名
    this.lineName  = lineName;               // 線路名
  }

  /**
   * 同一電柱判定
   */
  same(other) {
    return this.areaCode === other?.areaCode
        && this.lineCode === other?.lineCode
        && this.poleNo   === other?.poleNo;
  }

  /** 描画可否判定 */
  drawable() {
    return Number.isFinite(this.latitude)
        && Number.isFinite(this.longitude);
  }

  /** 電柱番号 表示文字列 */
  text() {
    return PoleItem.text(this);
  }

  /** 電柱情報 表示文字列 (線路 + 電柱番号) */
  longText() {
    return PoleItem.longText(this);
  }

  /** 電柱情報 表示文字列 (地区 + 線路 + 電柱番号) */
  fullText() {
    return PoleItem.fullText(this);
  }

  /** キー (地区 + 線路 + 電柱番号) */
  key() {
    return PoleItem.key(this);
  }

  /** 文字列化 */
  toString() {
    return PoleItem.toString(this);
  }

  //----------------------------------------------------------------------------
  // 静的メソッド
  //----------------------------------------------------------------------------
  /**
   * 同一電柱判定
   */
  static same(pole1, pole2) {
    return pole1 && pole1.areaCode === pole2?.areaCode
        && pole1 && pole1.lineCode === pole2?.lineCode
        && pole1 && pole1.poleNo   === pole2?.poleNo;
  }

  /** 電柱番号 表示文字列 */
  static text(pole) {
    if (!pole || !pole.poleNo) {
      return '';
    }

    // 末尾の枝番ゼロを取り除く
    return pole.poleNo.endsWith('-0')
        ? pole.poleNo.slice(0, -2)
        : pole.poleNo;
  }

  /** 電柱情報 表示文字列 (線路 + 電柱番号) */
  static longText(pole) {
    if (!pole || !pole.poleNo) {
      return '';
    }
    return pole.lineName
        + ' ' + pole.lineCode
        + '-' + PoleItem.text(pole)
  }

  /** 電柱情報 表示文字列 (地区 + 線路 + 電柱番号) */
  static fullText(pole) {
    if (!pole || !pole.poleNo) {
      return '';
    }
    return pole.areaName
        + ' ' + pole.lineName
        + ' ' + pole.lineCode
        + '-' + PoleItem.text(pole);
  }

  /** 電柱キー (地区コード + 線路コード + 電柱番号) */
  static key(pole) {
    if (!pole) return '-';
    return [
      pole.areaCode ?? '',
      pole.lineCode ?? '',
      pole.poleNo   ?? '',
    ].join('-');
  }

  /** 文字列化 */
  static toString(pole) {
    return PoleItem.fullText(pole);
  }

  /** ソート用比較関数 */
  static compare(lv, rv) {
    if (!lv && !rv) return 0;
    if (!lv) return 1;
    if (!rv) return -1;

    // 地区コード
    if (lv.areaCode !== rv.areaCode) {
      return lv.areaCode.localeCompare(rv.areaCode);
    }

    // 線路コード
    if (lv.lineCode !== rv.lineCode) {
      return lv.lineCode.localeCompare(rv.lineCode);
    }

    // 電柱番号
    return lv.poleNo.localeCompare(rv.poleNo);
  }
}

// 文字列化 - 地図電柱マスタに数字で登録してしまったので...
function toText(value, length) {
  return (value === null || value === undefined)
      ? ''
      : String(value).padStart(length, '0');
}

// デフォルトエクスポート
export default PoleItem;
